module.exports = __webpack_public_path__ + "static/media/fapes.489c1468.png";